export default __webpack_public_path__ + "static/media/1.fa81c6b9.svg";